import { useMemo } from "react"
import { getRolloutAssetFields } from "routes/asset-register/plugins/asset-mapping/rollout-asset-fields"

export function useAssetDisplayFields() {
    return useMemo(getFields, [])

    function getFields() {
        return getRolloutAssetFields().filter(({ field }) => !["tag", "description", "type"].includes(field))
    }
}
